<template>
  <img
    src="~/assets/icon/icon-whatsapp.svg"
    alt=""
  />
</template>
